import eventBus from '@/events';
import { ErrorMessagesCorrelationMap } from '@/enums/errorMessageCorrelationMap';

export default {
  methods: {
    handleError (error) {
      let event;
      if (!error.response) {
        event = {
          message: this.$t('ALERT_SERVER_UNREACHABLE')
        };
      } else if (error.response.status === 401) {
        event = {
          message: this.$t('ALERT_NOT_AUTHENTICATED'),
          type: 'warning'
        };
      } else if (error.response.status === 403) {
        event = {
          message: this.$t('ALERT_NOT_AUTHORIZED'),
          type: 'warning'
        };
      } else if (error.response.data.errors[0] !== null) {
        event = {
          message: this.messageToLabel(error.response.data.errors[0]),
          type: 'warning'
        };
      } else {
        event = {
          message: this.$t('ALERT_SERVER_INTERNAL_ERROR')
        };
      }
      eventBus.$emit('snackbar:show', event);
    },
    displaySnackbar (message, color) {
      eventBus.$emit('snackbar:show', {
        message: message,
        color: color
      });
    },
    displayErrorSnackbar (message) {
      this.displaySnackbar(message, 'error');
    },
    displayInfoSnackbar (message) {
      this.displaySnackbar(message, 'info');
    },
    displaySuccessSnackbar (message) {
      this.displaySnackbar(message, 'success');
    },
    displayWarningSnackbar (message) {
      this.displaySnackbar(message, 'warning');
    },
    messageToLabel (message) {
      if (ErrorMessagesCorrelationMap.has(message)) {
        return this.messageToLocal(ErrorMessagesCorrelationMap.get(message));
      } else {
        return this.$t('ALERT_SERVER_INTERNAL_ERROR');
      }
    },
    messageToLocal (message) {
      return this.$t(message);
    }
  }
};